'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.daysAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/daysAgo.js
// module id = 665
// module chunks = 0